import * as types from '../mutation-types'
import userService from '../api/services/users'
import customerService from '../api/services/customersService'
import Visitor_RequestService from '../api/services/Visitor_RequestService'
const state = {
  main: {},
  custmain: {},
  notificate: [],
  persons: [],
  getfile: [],
  Permission: [],
  rules: [],
  roles: ['customer'],
  budgetProject: [],
  budget: [],
  empAll: [],
  empConfig: { menuPin: false, bookRowsPerPage: 10, tscRowsPerPage: 5, prRowsPerPage: 10 },
  linestatus: false,
  visitorstatus: {},
  emailcuststatus: { status: null }
}

const getters = {
  empCode(state) {
    if (state.main.empCode) {
      return state.main.empCode
    }
    return ''
  },
  userCust(state) {
    if (state.custmain) {
      return state.custmain
    }
    return ''
  },
  empConfig(state) {
    return state.empConfig
  },
  rules(state) {
    return state.main.Rule
  },
  roles(state) {
    return state.roles
  },
  budgetProject(state) {
    return state.budgetProject
  },
  budget(state) {
    return state.budget
  },
  empMy(state) {
    return state.empMy
  },
  checkPermission: (state) => (value) => {
    if (value && value instanceof Array && value.length > 0) {
      const roles = state.main.Role
      const permissionRoles = value

      const hasPermission = roles.some((role) => {
        return permissionRoles.includes(role)
      })

      if (!hasPermission) {
        return false
      }
      return true
    } else {
      // console.error(`need roles! Like v-permission="['admin','editor']"`)
      // ไม่เป็น Array ให้แสดงไว้ก่อน
      return true
    }
  },
  isAuthen(state) {
    // if (state.main.success === undefined) {
    //   if (localStorage.getItem('tai_user') !== null) {
    //     state.main = JSON.parse(localStorage.getItem('tai_user'))
    //   } else {
    //     return false
    //   }
    // }
    return !!state.custmain.success
  },
  token(state) {
    // if (state.main.token === undefined) {
    //   if (localStorage.getItem('tai_user') !== null) {
    //     state.main = JSON.parse(localStorage.getItem('tai_user'))
    //   } else {
    //     return ''
    //   }
    // }
    return state.custmain.token
  },
  EmailCustStatus(state) {
    return state.emailcuststatus.status
  },
  lineStatus(state) {
    return state.linestatus.status
  },
  visitorStatus(state) {
    return state.visitorstatus || 'z' // ถ้าเป็น undefined ให้ return 'z'
  },
  prListCount(state) {
    if (!state.prListCount) {
      return {}
    }
    if (!state.prListCount.data) {
      return {}
    }
    if (state.prListCount.data.length > 0) {
      return state.prListCount.data[0]
    } else {
      return {}
    }
  }
}

const mutations = {
  [types.USER_AUTHEN](state, userAuth) {
    state.custmain = userAuth
    state.custmain.Email = userAuth.username
    // localStorage.setItem('tai_user', JSON.stringify(userAuth))
  },
  USER_VISITORSTATUS(state, payload) {
    state.visitorstatus = payload || {} // ป้องกัน undefined
  },
  [types.USER_LINESTATUS](state, linestatus) {
    state.linestatus = linestatus
  },
  [types.USER_PRLISTCOUNT](state, prListCount) {
    state.prListCount = prListCount
  },
  USER_EMAILCUSTSTATUS(state, status) {
    state.emailcuststatus = status
  },
  USER_BUDGET(state, budget) {
    state.budget = budget
  },
  USER_BUDGETPROJECT(state, budgetProject) {
    state.budgetProject = budgetProject
  },
  USER_GETALL(state, empAll) {
    state.empAll = empAll
    state.empMy = empAll.filter((e) => {
      if (e.EmpCode === state.main.empCode) return e
    })
  },
  // USER_AUTHEN (state, userAuth) {
  //   state.main = userAuth
  //   // localStorage.setItem('tai_user', JSON.stringify(userAuth))
  // },
  setNotificate(state, payload) {
    state.notificate = payload
    console.log('setNotificate', state)
  },
  setPersons(state, payload) {
    state.persons = payload
  },
  setDep(state, payload) {
    state.dep = payload
  },
  setgetFile(state, payload) {
    state.getfile = payload
  },
  setPermission(state, payload) {
    state.Permission = payload
  },
  setRole(state, payload) {
    state.main.Role = payload
    // state.roles = payload
  },
  setEmpConfig(state, payload) {
    state.empConfig = payload
  }
}

const actions = {
  customerSignIn: ({ state, commit, dispatch }, playload) => {
    // API request
    return customerService
      .signin(playload)
      .then((response) => {
        if (response) {
          console.log('customer signin', response.data)
          commit(types.USER_AUTHEN, response.data)
          dispatch('checkVisitorStatus')
          // dispatch('checkLineStatus')
          // dispatch('budgetProjectCode')
          // dispatch('budgetCode')
          // dispatch('getEmpAll')
          // dispatch('prListCount')
          // dispatch('getEmpConfig')
        } else {
          state.custmain = { success: false }
          state.notificate = []
          console.error('customer signin server error')
        }
      })
      .catch((error) => {
        state.custmain = { success: false }
        state.notificate = []
        console.error(error)
      })
  },
  signOut: ({ state }) => {
    console.log('signOut', state.custmain)
    // localStorage.setItem('tai_user', '{}')
    localStorage.removeItem('vuex')
    state.custmain = {}
    state.notificate = []
  },
  checkEmailCustStatus({ state, commit }, message) {
    let data = message

    return userService
      .emailcustStatus(data)
      .then((res) => {
        console.log('emailcuststatus', res)
        commit('USER_EMAILCUSTSTATUS', res) // ใช้ชื่อ Mutation โดยตรง
        return state.emailcuststatus
      })
      .catch((err) => {
        console.error('status emailcust err', err)
        state.emailcuststatus.status = false
        return state.emailcuststatus
      })
  },
  checkVisitorStatus({ state, commit }) {
    let data = { Email: state.custmain.Email }
    console.log('status visitor mail', data)
    return Visitor_RequestService.requestsListByParam(data)
      .then((response) => {
        commit('USER_VISITORSTATUS', response.data || {})
        console.log('status visitor then', response.data)

        return response.data || {}
      })
      .catch((err) => {
        console.log('status visitor err', err)
        commit('USER_VISITORSTATUS', {}) // ตั้งค่าเป็น object ว่างแทน undefined
        return {}
      })
  },
  checkLineStatus({ state, commit }) {
    let data = { emp: state.custmain.empCode }
    return userService
      .linestatus(data)
      .then((res) => {
        commit(types.USER_LINESTATUS, res)
        console.log('status line then', res)
        // state.linestatus = res
        return state.linestatus
      })
      .catch((err) => {
        console.log('status line err', err)
        state.linestatus.status = false
        return state.linestatus
      })
  },
  lineNotify({ state }, playload) {
    return userService
      .linenotify(playload)
      .then((res) => {
        return res
      })
      .catch((err) => {
        return err
      })
  },
  emailNotify({ state }, playload) {
    return userService
      .linenotify(playload)
      .then((res) => {
        return res
      })
      .catch((err) => {
        return err
      })
  },
  lineOTP({ state }, playload) {
    return userService
      .lineotp(playload)
      .then((res) => {
        return res
      })
      .catch((err) => {
        return err
      })
  },
  emailOTP({ state }, playload) {
    return userService
      .emailotp(playload)
      .then((res) => {
        return res
      })
      .catch((err) => {
        return err
      })
  },
  emailotpcustomer({ state }, playload) {
    return userService
      .emailotpcustomer(playload)
      .then((res) => {
        return res
      })
      .catch((err) => {
        return err
      })
  },
  emailcustomer({ state }, playload) {
    return userService
      .emailcustomer(playload)
      .then((res) => {
        return res
      })
      .catch((err) => {
        return err
      })
  },
  lineOTPCheck({ state }, playload) {
    return userService
      .lineotpcheck(playload)
      .then((res) => {
        return res
      })
      .catch((err) => {
        return err
      })
  },
  changeRole({ commit }, playload) {
    commit('setRole', playload)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}

// const mutations = {
//   [types.FETCH_USER] (state, users) {
//     state.custmain = users
//   },
//   setloginUser (state, loginUser) {
//     state.custmain.loginuser = loginUser.data
//     localStorage.setItem('taiuser', JSON.stringify(loginUser.data))
//   }
// }
